<template>
  <div class="sky-hc-article-manage">
    <div class="sky-hc-article-manage__left">
      <el-button
        class="sky-hc-article-manage__left-add-btn"
        icon="el-icon-plus"
        size="medium"
        @click="handleAddSubNewCategory({ id: 0 }, CATEGORY_TYPE.ARTICLE)"
        >{{ $t('articleManage.addNewClass') }}</el-button
      >
      <classify-tree
        v-if="categoryList.length"
        :data="categoryList"
        :actions="categoryActions"
        @handleTreeClick="handleTreeClick"
        :type="CATEGORY_TYPE.ARTICLE"
      />
    </div>
    <article-list ref="articleList" />
  </div>
</template>
<script>
import { Button } from 'element-ui'

import ArticleList from './components/articleList'

import { updateCategory, deleteCategory } from '@/api/articleManage'
import ClassifyTree from '@/components/classifyTree'
import category from '@/mixins/category'

import { CATEGORY_TYPE } from '@/utils/enum'

export default {
  name: 'ArticleManage',
  components: {
    ClassifyTree,
    ArticleList,
    [Button.name]: Button
  },
  mixins: [category],
  data() {
    return {
      categoryActions: [
        {
          label: this.$t('articleManage.addSubNewClass'),
          icon: 'el-icon-plus',
          handler: this.handleAddSubNewCategory,
          enabled: {
            deep: {
              is: [0, 1]
            }
          }
        },
        {
          label: this.$t('articleManage.edit'),
          icon: 'el-icon-edit',
          handler: this.handleEditCategory,
          enabled: {
            deep: {
              is: [1, 2]
            }
          }
        },
        {
          label: this.$t('articleManage.del'),
          icon: 'el-icon-delete',
          handler: this.handleDelCategory,
          enabled: {
            deep: {
              is: [1, 2]
            },
            isDefault: {
              is: [false]
            }
          }
        }
      ],
      currentCategory: {},
      CATEGORY_TYPE
    }
  },
  created() {
    this.handleGetCategoryList(CATEGORY_TYPE.ARTICLE, true)
  },
  methods: {
    handleEditCategory(item) {
      this.$prompt(
        `<span><i class="red-font">*</i>${this.$t('articleManage.categoryName')}</span>`,
        this.$t('articleManage.editCategory'),
        {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          inputValue: item.name,
          dangerouslyUseHTMLString: true,
          customClass: 'sky-hc-input-dialog',
          closeOnClickModal: false
        }
      ).then(({ value }) => {
        updateCategory({
          id: item.id,
          name: value,
          parentId: item.parentId
        }).then(() => {
          this.handleGetCategoryList(CATEGORY_TYPE.ARTICLE, true)
        })
      })
    },
    handleDelCategory(item) {
      deleteCategory({ id: item.id }).then(() => {
        this.handleGetCategoryList(CATEGORY_TYPE.ARTICLE, true)
      })
    },
    handleTreeClick(item) {
      this.currentCategory = item
      this.$nextTick(() => {
        this.$refs.articleList.handleCategoryChange(item)
      })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-article-manage) {
  display: flex;
  @include e(left) {
    width: 298px;
    flex-shrink: 0;
  }
  @include e(left-add-btn) {
    margin: 20px 19px 25px 9px;
    width: 270px;
  }
}
</style>
